import styled from 'styled-components';

import { theme } from '../../../../../common/ui/theme';

export const DashedOfferCardOutline = styled.div`
    height: 145px;
    justify-content: center;
    align-items: center;
    color: ${theme.colors.foreground.subtle};
    display: flex;

    // Styles for a custom dashed border with 6px dash and 6px gap
    background-image: repeating-linear-gradient(
            0deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        ),
        repeating-linear-gradient(
            90deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        ),
        repeating-linear-gradient(
            180deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        ),
        repeating-linear-gradient(
            270deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        );
    background-size:
        1px 100%,
        100% 1px,
        1px 100%,
        100% 1px;
    background-position:
        0 0,
        0 0,
        100% 0,
        0 100%;
    background-repeat: no-repeat;
`;
